// src/modules/app-views/_apps/appsindico/units/pages/Document/tabs/TitularTab.jsx
// *******************************************************************************
// TITULAR TAB
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Row, Col, Card, Typography } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { useDocumentContext } from 'components/core/DocumentProvider';
import SimpleSelectAsyncEntities from 'components/SimpleComponents/SimpleSelectAsyncEntities';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const { Text } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const TitularTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <>
      <Card size="small" title={translateX('partner_owner')} className="mb-3">
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleSelectAsyncEntities
              name="titularEntityId"
              label="owner"
              placeholder="search_entity"
              entityProfiles={['customer', 'contact']}
            />
          </Col>
        </Row>
      </Card>

      {data?.__titular && (
        <Card size="small" title={translateX('owner_info')}>
          <Row gutter={ROW_GUTTER}>
            <Col xs={24} sm={8}>
              <Text type="secondary">{translateX('name')}</Text>
              <div>{data.__titular?.name || '-'}</div>
            </Col>
            <Col xs={24} sm={8}>
              <Text type="secondary">{translateX('phone')}</Text>
              <div>{data.__titular?.phone || '-'}</div>
            </Col>
            <Col xs={24} sm={8}>
              <Text type="secondary">{translateX('email')}</Text>
              <div>{data.__titular?.email || '-'}</div>
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default TitularTab;
